import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("privacy-policy", {
    model: {
      defaults: {
        components: html`
          <section class="container mx-auto px-4 md:px-20 py-12 text-gray-800">
            <div class="max-w-4xl mx-auto">
              <h2 class="text-3xl md:text-4xl font-bold text-[#0083D7] mb-6">
                Privacy Policy
              </h2>

              <p class="mb-4">
                We are committed to protecting your personal data. This Privacy
                Policy outlines how we collect, use, and safeguard your
                information when you use our cargo services.
              </p>

              <div class="space-y-6">
                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    1. Information We Collect
                  </h3>
                  <p>
                    We may collect personal information such as your name,
                    email, phone number, address, and shipment details when you
                    request our services or contact our support team.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    2. How We Use Your Information
                  </h3>
                  <p>
                    Your information is used to process shipments, track orders,
                    provide customer support, comply with legal obligations, and
                    improve our services.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    3. Sharing of Information
                  </h3>
                  <p>
                    We do not sell your information. We may share your data with
                    third-party logistics providers, customs agencies, or
                    partners as required to fulfill your shipment.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    4. Data Security
                  </h3>
                  <p>
                    We implement strong security measures to protect your
                    personal data from unauthorized access, loss, or misuse.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    5. Cookies & Tracking
                  </h3>
                  <p>
                    Our website may use cookies to enhance user experience,
                    analyze website traffic, and personalize content. You can
                    control cookie settings in your browser.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    6. Your Rights
                  </h3>
                  <p>
                    You have the right to access, correct, or delete your
                    personal data. You may also request to opt-out of marketing
                    communications at any time.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    7. Third-Party Links
                  </h3>
                  <p>
                    Our website may contain links to third-party sites. We are
                    not responsible for their privacy practices and encourage
                    you to read their privacy policies.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-[#FF6700] mb-2">
                    8. Changes to This Policy
                  </h3>
                  <p>
                    We may update this Privacy Policy occasionally. Changes will
                    be posted on this page with a revised effective date.
                  </p>
                </div>
              </div>

              <p class="mt-8 text-sm text-gray-500">
                If you have any questions or concerns about our privacy
                practices, please contact us at support@yourcompany.com.
              </p>
            </div>
          </section>
        `,
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "product-details-edit",
          },
        ],
      },
    },
  });
};
